import React, { useState, useEffect } from "react";
import PopUp from "../../ReactPortal/PortalPopUp";
import styles from "../OliPopUp.module.scss";
import Oli_Icon from "@/components/Logos/OliAI";
import { useSelector } from "react-redux";

export default function OliPopUpMini({ firstName, isSubmenuVisible, isPDP, isDesigner, isPLP, isHomePage, fetchOliStatus, dispatch, openOliPopup }) {
  const [showOliChatBubble, setShowOliChatBubble] = useState(false);
  const [hasAnimated, setHasAnimated] = useState(false);
  const isPWA = useSelector((state) => state.pwa.is_PWA);

    useEffect(() => {
    const timer = setTimeout(() => {
      if (!sessionStorage?.getItem("oliChatClosed")) {
        setShowOliChatBubble(true);
        setHasAnimated(true);
      }
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  const handleReplyClick = () => {
    fetchOliStatus(false);
    dispatch(openOliPopup());
    sessionStorage?.setItem("oliChatClosed", "true");
    setShowOliChatBubble(false);
  };

  const handleCloseClick = () => {
    setShowOliChatBubble(false);
    sessionStorage?.setItem("oliChatClosed", "true");
  };

  return (
    <>
    {showOliChatBubble && (
        <PopUp
        onClose={handleCloseClick}
        show={showOliChatBubble}
        wrapperClass={`${styles.oli_popup_wrapper} ${styles.collapsed} ${styles.chatBubble} ${hasAnimated ? styles.animateBubble : ""} ${isPDP ? "pdp_page" : ""} ${isPWA ? styles.bubble_app_position : ""} oli-chat-bubble-popup`}
        closeBtnClass={`${isPDP ? "ga-oli-chat-close-pdp" : isDesigner? "ga-oli-chat-close-designer": isPLP ? "ga-oli-chat-close-plp" : isHomePage? "ga-oli-chat-close-home": ""}`}
        >
        <div className={`${styles.oli_popup}`}>
            <div className={styles.heading_wrapper}>
            <div className={styles.oli_icon_wrapper}>
                <Oli_Icon height="30" width="30" className={styles.icon} />
            </div>
            <div className={styles.text_wrapper}>
                <h2 className={`"small-md small-sm small-xs bold ${styles.popup_title}`}>
                Chat with Oli
                </h2>
            </div>
            </div>
            <p className={`small-md small-sm small-xs ${styles.popup_description}`}>
              Hi{firstName ? " " + firstName : ""}, looking for something in particular?
            </p>
            <input
              type="text"
              placeholder="Click to reply"
              readOnly
              onClick={handleReplyClick}
              className={`x-small-md xx-small-sm x-small-xs ${styles.dummy_input} ${isPDP ? "ga-oli-chat-click-pdp" : isDesigner? "ga-oli-chat-click-designer": isPLP ? "ga-oli-chat-click-plp" : isHomePage? "ga-oli-chat-click-home": ""}`}
            />
        </div>
        </PopUp>
    )}
    </>
  );
}
